import { combineReducers } from "redux";
import map from "./map";
import filters from "./filters";
import linkRestriction from "./linkRestriction";
import router from "./router";
import city from "./city";
import sidebar from "./sidebar";
import mapLayer from "./mapLayer";
import user from "./user";
import globals from "./globals";
import regulation from "./regulation/regulation";
import proposedLinks from "./regulation/proposedLinks";
import CreateRegulation from "./regulation/CreateRegulation";
import batchSelection from "./regulation/batchSelection";
import regulationListView from "./regulation/regulationListView";
import publicViewer from "./publicViewer";
import curbManagerMap from "./regulation/curbmanagerMap";
import AssetData from "./assets";
import editRegulation from "./regulation/editRegulation";
import MultiLingual from "./multilingual";
import LiveData from "./liveData";
import Scenarios from "./Scenarios";
import Analyzer from "./Analyzer";
import regulationTemplates from "./regulation/regulationTemplates";
import WorkOrders from "./workOrders";
import Dashboards from "./Dashboards";
import editBatchSelection from "./regulation/editBatchSelection";
import editParkingRates from "./regulation/editParkingRates";
import Projects from "./Projects";
import Permits from "./regulation/PermitsListView";
import QuickActions from "./QuickActions";
import Feedback from "./feedback";

export const rootReducer = combineReducers({
    Analyzer,
    AssetData,
    batchSelection,
    editBatchSelection,
    editParkingRates,
    city,
    CreateRegulation,
    curbManagerMap,
    Dashboards,
    editRegulation,
    Feedback,
    Permits,
    filters,
    globals,
    linkRestriction,
    LiveData,
    map,
    mapLayer,
    MultiLingual,
    proposedLinks,
    publicViewer,
    regulation,
    regulationListView,
    regulationTemplates,
    router,
    Scenarios,
    sidebar,
    user,
    WorkOrders,
    Projects,
    QuickActions
});

export type RootState = ReturnType<typeof rootReducer>;
